const urls = []

export default url => {
    if (!url || urls.indexOf(url) > -1) {
        return
    }

    urls.push(url)

    const tag = document.createElement('script')
    tag.src = url
    tag.async = true

    const firstScriptTag = document.getElementsByTagName('script')[0]

    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}